import { Component, Input, OnInit } from '@angular/core';
import { UserDivision } from '../shared/types';

@Component({
  selector: 'pitch-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() userDivision: UserDivision = UserDivision.WMG;

  UserDivision = UserDivision;

  public get currentYear(): number {
    return new Date().getFullYear();
  }

  constructor() {}

  ngOnInit() {}
}
